import type { CSSProperties } from 'react'

interface Eigenschaften {
  artikel: { artikelnummer: string; bezeichnung: string }[]
  wert: string
  onChange: (artikelnummer: string) => void
  /** Text der leeren Wahl; ohne Angabe gibt es keine leere Wahl. */
  leer?: string
  disabled?: boolean
  style?: CSSProperties
}

/** Ein Artikel aus einer Liste - immer als „Nummer Bezeichnung“, damit die Nummer überall gleich sichtbar ist. */
export default function ArtikelAuswahl({ artikel, wert, onChange, leer, disabled, style }: Eigenschaften) {
  return (
    <select value={wert} onChange={(e) => onChange(e.target.value)} disabled={disabled} style={style}>
      {leer !== undefined && <option value="">{leer}</option>}
      {artikel.map((a) => (
        <option key={a.artikelnummer} value={a.artikelnummer}>
          {a.artikelnummer} {a.bezeichnung}
        </option>
      ))}
    </select>
  )
}
